// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__EujJi","body":"style_body__D26Fq","foot":"style_foot__q5ap4","CheckBox":"style_CheckBox__qaLQw"};